// 음성 녹음 공용 로직(빠른 녹음 버튼·일기장이 함께 쓴다). 분석하지 않고 보관만(decisions).
import { ref } from 'vue'

export function useRecorder() {
  const recording = ref(false)
  const sec = ref(0)
  let rec: MediaRecorder | null = null
  let chunks: Blob[] = []
  let timer: number | undefined
  let stream: MediaStream | null = null

  async function start(): Promise<boolean> {
    try {
      stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      chunks = []; sec.value = 0
      rec = new MediaRecorder(stream)
      rec.ondataavailable = e => e.data.size && chunks.push(e.data)
      rec.start()
      recording.value = true
      timer = window.setInterval(() => sec.value++, 1000)
      return true
    } catch { return false }
  }

  function stop(): Promise<{ blob: Blob; sec: number } | null> {
    return new Promise(res => {
      if (!rec || !recording.value) return res(null)
      rec.onstop = () => {
        stream?.getTracks().forEach(t => t.stop())
        clearInterval(timer)
        recording.value = false
        res({ blob: new Blob(chunks, { type: rec!.mimeType || 'audio/webm' }), sec: Math.max(sec.value, 1) })
      }
      rec.stop()
    })
  }

  return { recording, sec, start, stop }
}

export function blobToB64(blob: Blob): Promise<string> {
  return new Promise(res => { const fr = new FileReader(); fr.onload = () => res(String(fr.result).split(',')[1] || ''); fr.readAsDataURL(blob) })
}
export const fmtSec = (s = 0) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
